export default __webpack_public_path__ + "static/media/map-pin.e4a5fd2b.svg";